import React, { useEffect, useState } from 'react';
import CreateScreenModal from './create-screen-modal';
import moment from 'moment';
import { KITCHEN_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { FormDataType, ScreenType } from 'models/screen.model';
import ActiveTag from 'components/base/active-tag';
import { useNavigate } from 'react-router';

const ScreenCard = ({
  data,
  onEditSuccess,
  onDeleteSuccess
}: {
  data: ScreenType;
  onEditSuccess?: (arg0: FormDataType) => void;
  onDeleteSuccess?: (arg0: string) => void;
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const formattedDate = moment(data.created_at).format('MMM D, YYYY, h:mma');
  const role = localStorage.getItem(STORAGE_KEYS.ROLE);
  const [activeScreen, setActiveScreen] = useState(false);
  const navigate = useNavigate();
  const details = localStorage.getItem(STORAGE_KEYS.SCREEN_DETAILS);

  useEffect(() => {
    setActiveScreen(details ? JSON.parse(details)?.id === data?.id : false);
  }, []);

  return (
    <div>
      <div
        onClick={() => {
          setActiveScreen(true);
          localStorage.setItem(STORAGE_KEYS.SCREEN_DETAILS, JSON.stringify(data));
          localStorage.setItem(STORAGE_KEYS.IS_BRAND_SPLIT_SCREEN, JSON.stringify(true));
          navigate(KITCHEN_ROUTE_KEYS.LIVE_TRIPS);
          window.location.reload();
        }}
        className={`border flex flex-col gap-3 justify-between p-6 rounded-[8px] hover:cursor-pointer ${
          activeScreen ? ' border-red-3' : 'border-[#EDEDEE]'
        }`}>
        <ActiveTag active={data.active} activeText='Active' inActiveText='Deactivated' />
        <div className=''>
          <p className='font-medium mb-1'>Screen {data.name} </p>
          <p className='text-[#858585]'>Created {formattedDate}</p>
        </div>

        <div className='flex flex-wrap gap-1'>
          {data.brands.map((item, index) => (
            <img
              key={index}
              src={item.logo}
              alt='logo'
              className='w-8 h-8 object-cover rounded-full -ml-2'
            />
          ))}
        </div>
        {role?.includes('ADMIN') && (
          <p
            onClick={(e) => {
              e.stopPropagation();
              setShowEditModal(true);
            }}
            className='text-[#E60A2B] cursor-pointer  underline font-medium'>
            Edit Screen
          </p>
        )}
      </div>
      <CreateScreenModal
        createScreenData={data}
        type='edit'
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onEditSuccess={onEditSuccess}
        onDeleteSuccess={onDeleteSuccess}
      />
    </div>
  );
};

export default ScreenCard;
